import axios from 'axios';

export default {
    name: 'enter-code',
    // Initial props provided by Login.vue.
    props: ['sentVia', 'user', 'token', 'code'],
    // Initial data.
    data() {
        return {
            phoneDescription: '',
            emailDescription: '',
            verificationCode: this.code !== null ? this.code : '',
            buttonClasses: ['is-fullwidth'],
            loadingState: false
        };
    },
    async created() {
        // If the token doesn't exist, we'll need to utilize the hash.
        if (!this.token) {
            let data = {
                hash: process.env.VUE_APP_QV4_API_HASH,
                name: 'WEB'
            };

            // Go get the environment token.
            await axios
                .post(`${process.env.VUE_APP_QV4_API}/environments/login`, data)
                .then(response => {
                    // Set the new token.
                    this.token = response.data.token;
                })
                .catch(() => {});
        }
    },
    // Handle focus on the first code input when the component is mounted.
    mounted() {
        this.$refs.verificationCode.$el.firstChild.focus();
    },
    computed: {
        isCompleted() {
            return this.verificationCode.length === 4;
        }
    },
    // Methods needed for this component.
    methods: {
        // Resend a code if the Resend link is clicked.
        onClickResendCode(e) {
            e.preventDefault();
            this.$emit('currentAlert', null);

            // Hit the API to resend a new code.
            axios
                .get(
                    `${
                        process.env.VUE_APP_QV4_API
                    }/users/verification-code?username=${
                        this.user.username
                    }`,
                    {
                        headers: {
                            'x-api-key': this.token
                        }
                    }
                )
                // If that code is received successfully, stay on component and notify user.
                .then(() => {
                    // Set alert data.
                    let alert = {
                        message: this.$t('HC_VERIFICATION_CODE_RESENT'),
                        status: '',
                        icon: 'check-circle-outline'
                    };

                    // Send alert data to parent component.
                    this.$emit('currentAlert', alert);
                })
                // If the request failed.
                .catch(() => {
                    let alert = {
                        message: this.$t('HC_OOPS_SOMETHING_WENT_WRONG'),
                        status: 'danger',
                        icon: 'exclamation-circle-outline'
                    };

                    // Send alert data to parent component.
                    this.$emit('currentAlert', alert);
                });
        },
        onSubmit() {
            // Add the loading spinner icon to the button.
            this.loadingState = true;

            this.$emit('currentAlert', null);

            // Add the loading spinner icon to the button.
            this.buttonClasses.push('button-loading');

            let data = {
                code: this.verificationCode,
                username: this.user.username
            };

            // Send validation code
            axios
                .post(
                    `${process.env.VUE_APP_QV4_API}/users/verify-code`,
                    data,
                    {
                        headers: {
                            'x-api-key': this.token
                        }
                    }
                )
                // Handle success
                .then(response => {
                    // Remove the loading spinner icon from button, and show success icon.
                    let index = this.buttonClasses.indexOf('button-loading');

                    if (index > -1) {
                        this.buttonClasses.splice(index, 1);
                    }

                    // Update token to user token
                    this.$emit('authToken', response.data.token);

                    // Transition to Get Code component.
                    this.$emit('currentView', 'reset-password');
                    this.$emit(
                        'currentTransition',
                        'component-slide-fade-left'
                    );
                })
                // If the API request fails due to connectivity or any other reason.
                .catch(() => {
                    // Remove loading spinner on button
                    this.loadingState = false;

                    // If verification code is not valid
                    // Set alert data.
                    let alert = {
                            message: this.$t('HC_OOPS_CODE_ERROR'),
                            status: 'danger',
                            icon: 'exclamation-circle-outline'
                        },
                        index = this.buttonClasses.indexOf('button-loading');

                    // Remove loading spinner icon from button.
                    if (index > -1) {
                        this.buttonClasses.splice(index, 1);
                    }

                    // Send alert data to parent component.
                    this.$emit('currentAlert', alert);
                });
        }
    }
};
